import RolesService from "../../services/roles.service";

const state = {
    roles: [],
    rolesOfProject: [],
    permissions: [],
    userRoles: [],
    projectPermissions: [],
    rolePermissions: [],
    userProjectRoles: [],

};

const mutations = {
    set_roles(state, payload) {
        state.roles = payload;
    },
    set_roles_project(state, payload) {
        state.rolesOfProject = payload;
    },
    set_permissions(state, payload) {
        state.permissions = payload;
    },
    set_project_permissions(state, payload) {
        state.projectPermissions = payload;
    },
    set_role_permissions(state, payload) {
        state.rolePermissions = payload;
    },
    set_user_project_roles(state, payload) {
        state.userProjectRoles = payload;
    },
    set_user_roles(state, payload) {
        state.userRoles = payload;
    },
    set_none() {
    }
};

const actions = {

        async getRoles({commit}) {
            const roles = await RolesService.getRolesService();
            commit("set_roles", roles);
            return roles;
        },
        async getRolesOfProject({commit}, payload) {
            const rolesofproject = await RolesService.getRolesOfProjectsService(payload);
            commit("set_roles_project", rolesofproject);
            return rolesofproject;
        },
        async getUserProjectRoles({commit}, {userId, projectId}) {
            //   console.log(userId,projectId)
            const userprojectroles = await RolesService.getUserProjectRoles(userId, projectId);
            commit("set_user_project_roles", userprojectroles);
            return userprojectroles;
        },
        async getUserRoles({commit}, {id}) {
            const userroles = await RolesService.getUserRoles(id);
            commit("set_user_roles", userroles);
            return userroles;
        },
        async getPermissions({commit}) {
            const permissions = await RolesService.getPermissionsService();
            commit("set_permissions", permissions);
            return permissions;
        },
        async getPermissionsByProject({commit}, payload) {
            const permissions = await RolesService.getPermissionsByProjectService(payload);
            commit("set_project_permissions", permissions);
            return permissions;
        },
        async getRolePermissions({commit}, payload) {
            const rolepermissions = await RolesService.getRolePermissions(payload);
            commit("set_role_permissions", rolepermissions);
            return rolepermissions;
        },
        async addRole({commit}, payload) {
            const addrole = await RolesService.addRoleService(payload);
            commit("set_none", addrole);
            return addrole;
        },
        async addGroup({commit}, payload) {
            const addgroup= await RolesService.addGroupService(payload);
            commit("set_none", addgroup);
            return addgroup;
        },
        async addUserRole({commit}, {userId, roleId}) {
            const adduserrole = await RolesService.addUserRoleService(userId, roleId)
            commit("set_none", adduserrole);
            return adduserrole;
        },

        async addRolePermission({commit}, payload) {
            const rp = await RolesService.addRolePermission(payload);
            commit("set_none", rp);
            return rp;
        },
        async addPermission({commit}, payload) {
            const addp = await RolesService.addPermissionService(payload);
            commit("set_none");
            return addp;
        },
        async deleteRole({commit}, payload) {
            const deleterole = await RolesService.deleteRoleService(payload);
            commit("set_none");
            return deleterole;
        },
        async deleteRolePermission({commit}, payload) {
            const deleterolepermission = await RolesService.deleteRolePermissionService(payload);
            commit("set_none");
            return deleterolepermission;
        },
        async deleteUserRole({commit}, payload) {
            const deleteuserrole = await RolesService.deleteUserRoleService(payload);
            commit("set_none", deleteuserrole);
            return deleteuserrole
        }

    }
;


export default {
    namespaced: true,
    state,
    mutations,
    actions
}
